var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44 44V20L24 4L4 20L4 44H16V26H32V44H44Z",
    fill: "none",
    stroke: "#333",
    strokeWidth: 4,
    strokeLinejoin: "miter"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 44V34",
    stroke: "#333",
    strokeWidth: 4,
    strokeLinecap: "butt",
    strokeLinejoin: "miter"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeTwo);
export default __webpack_public_path__ + "static/media/home-two.c14208b13d46034a10dba4d5599ec547.svg";
export { ForwardRef as ReactComponent };